<ion-modal
  id="assistant-subscription-plan-recommendation-modal"
  [breakpoints]="[0, 1]"
  [expandToScroll]="true"
  [handle]="false"
  [initialBreakpoint]="breakpoint()"
  [isOpen]="isOpen()"
  (didDismiss)="didDismiss()"
  (willDismiss)="willDismiss()"
>
  <ng-template>
    <div
      class="flex flex-col ion-content-scroll-host min-h-full overflow-auto bg-gradient"
    >
      <div class="flex-auto">
        <div class="p-4 pb-2">
          <div class="flex flex-row">
            <div class="flex-initial">
              <ion-icon
                class="size-[24px]"
                color="main-button"
                name="chevron-down-outline"
                (click)="close()"
              ></ion-icon>
            </div>
          </div>
          @if (subscriptionPlans().length > 1) {
            <ion-segment [value]="selectedPlanCode()">
              @for (item of subscriptionPlans(); track item.id) {
                <ion-segment-button
                  [value]="item.code"
                  (click)="selectPlan(item)"
                >
                  <ion-label>
                    {{ item.title }}
                  </ion-label>
                </ion-segment-button>
              }
            </ion-segment>
          }
        </div>
      </div>
      <div class="flex-1">
        <div class="ion-content-scroll-host scrollable-content overflow-auto">
          <div class="px-4 pb-3">
            <app-assistant-subscription-list-plan
              [ableToSelectPlan]="isProcessingPayment() === false"
              [(selectedPlanCode)]="selectedPlanCode"
              [(selectedPlanId)]="selectedPlanId"
              (loadingAvailablePlanChanged)="
                onLoadingAvailablePlansChanged($event)
              "
              (planClicked)="onPlanClicked()"
              (selectedPlanStoreProductIdChange)="
                selectedPlanStoreProductId.set($event)
              "
            />
          </div>
        </div>
      </div>
      <div class="flex-auto">
        <!-- shadow-[0px_4px_22px_0px_#00000040] -->
        <div class="px-4 footer-section">
          <ion-button
            class="mt-5"
            color="main-button"
            expand="block"
            shape="round"
            [disabled]="ableToPay() === false"
            (click)="fetchProduct()"
          >
            @if (isProcessingPayment()) {
              <ion-spinner name="lines-small"></ion-spinner>
            } @else {
              <div class="mx-auto text-white text-sm font-medium">
                Start
                <span class="font-bold">{{ abbreviation }}</span>
                Membership
              </div>
              <ion-icon
                class="text-white text-2xl"
                name="chevron-forward-circle"
              ></ion-icon>
            }
          </ion-button>
          <p class="text-dark text-xs font-normal mt-3 text-center">
            By subscribing you agree to our
            <u class="font-medium" (click)="toTOC()">Terms of Service</u>.
          </p>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
